import { reducer, initialState } from './reducer'
import * as actions from './actions'

export type { LOGIN } from './actions'
export type { LoginSliceType } from './reducer'
export const LoginReducer = { reducer, initialState, actions }
